/* OSIRIS */
export const OSIRIS_COUPON_METHOD = [
  { id: 1, label: "Daily coupon" },
  { id: 2, label: "Full coupon" },
  { id: 3, label: "Standard" },
];

export const OSIRIS_INTERPOLATION_PD = [
  { id: 1, label: "Linear" },
  { id: 2, label: "Quadratic" },
  { id: 3, label: "Cubic" },
];

export const OSIRIS_ACTUARIAL_RATE_RULE = [
  { id: 1, label: "Daily coupon" },
  { id: 2, label: "Standard" },
];

export const OSIRIS_BUCKET_RULE = [
  { id: 1, label: "Rating downgrad" },
  { id: 2, label: "Rating downgrad + Watchlist" },
];

export const OSIRIS_SCOPE = [
  { id: 1, label: "Full scope" },
  { id: 2, label: "Full scope except simulated lines" },
  { id: 3, label: "Only simulated lines" },
];

export const OSIRIS_DATASET_TYPES = [
  { id: 1, label: "Static data" },
  { id: 2, label: "PD" },
  { id: 3, label: "LGD" },
  { id: 4, label: "EAD" },
];

/* HORUS */
export const HORUS_DATASET_TYPES = [
  { id: 1, label: "Static data" },
  { id: 2, label: "EAD" },
];

export const HORUS_AMORTIZATION_TYPE = [
  { id: "Linear", name: "Linear" },
  { id: "Actuarial", name: "Actuarial" },
  { id: "Constant", name: "Constant" },
  { id: "All", name: "All" },
];

export const HORUS_ACTUARIAL_RATE_RULE = [
  { id: 1, label: "Daily coupon stepped" },
  { id: 2, label: "Daily coupon average" },
  { id: 3, label: "Standard" },
];

export const HORUS_COUPON_METHOD = [
  { id: 1, label: "Daily coupon stepped" },
  { id: 2, label: "Daily coupon average" },
  { id: 3, label: "Standard" },
  { id: 4, label: "Full coupon" },
];
